import React from "react";
import {
  Button,
  PanelDialog,
  PanelHeading,
  PanelRow,
  PanelSpacer,
  PanelActions,
  BoldText,
} from "@backslashbuild/pp-ui";
import { useUpdateField } from "./api";
import { publish } from "../../pubSub";
import { useHistory } from "react-router-dom";

function DeleteLeadButton({ id }) {
  const history = useHistory();

  // you have to query to see if there are any currently staged pay runs and then disable the button.
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const deleteLead = useUpdateField({ id, formName: "" });

  async function handleSubmit() {
    try {
      const response = await deleteLead({ key: "IsActive", value: "false" });

      if (response.isSuccess) {
        publish("notification", "Lead deleted");
        history.goBack();
      } else {
        publish(
          "notification",
          <>
            Unable to delete lead
            <ul>
              {response.errors.map((error) => (
                <li>{error}</li>
              ))}
            </ul>
          </>
        );
      }
    } catch (e) {
      console.error(e, "error cancelling payslip");
      publish("notification", "A network error occured.");
    }
  }

  return (
    <>
      <Button variant="secondary" onClick={() => setDialogOpen(true)} large>
        Delete Lead
      </Button>
      <PanelDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <PanelHeading>Delete Lead</PanelHeading>
        <PanelSpacer large />
        <PanelRow>
          <BoldText>Are you sure you want to delete this lead?</BoldText>
        </PanelRow>
        <PanelSpacer large />
        <PanelActions>
          <Button variant="secondary" onClick={() => setDialogOpen(false)}>
            No, Don't delete
          </Button>
          <Button onClick={handleSubmit}>Yes, delete lead</Button>
        </PanelActions>
        <PanelSpacer large />
      </PanelDialog>
    </>
  );
}

export default DeleteLeadButton;
